import { render, staticRenderFns } from "./ColorModal.vue?vue&type=template&id=c876f942"
import script from "./ColorModal.vue?vue&type=script&lang=js"
export * from "./ColorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports